import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import itTranslation from './locales/it/translation.json';
import deTranslation from './locales/de/translation.json';
import esTranslation from './locales/es/translation.json';
import frTranslation from './locales/fr/translation.json';
import plTranslation from './locales/pl/translation.json';
import ptTranslation from './locales/pt/translation.json';
import zhTranslation from './locales/zh/translation.json';

/**
 * Le stesse otto lingue del check-in online. Le sei nuove coprono oggi le
 * sezioni che riguardano il soggiorno (prenotazione, extra, "il mio
 * soggiorno", chat, home): per il resto (guide delle città, audio tour,
 * eventi) l'app ricade sull'inglese finché non arrivano le traduzioni.
 */
const resources = {
  en: { translation: enTranslation },
  it: { translation: itTranslation },
  de: { translation: deTranslation },
  es: { translation: esTranslation },
  fr: { translation: frTranslation },
  pl: { translation: plTranslation },
  pt: { translation: ptTranslation },
  zh: { translation: zhTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'it', 'de', 'es', 'fr', 'pl', 'pt', 'zh'],
    // "de-AT" → "de": la lingua del telefono basta, senza la regione.
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'nva-language'
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

/**
 * `t` per i moduli senza React (lib, hook di soli dati, class component):
 * i tipi di i18next con questo TypeScript rendono `i18n.t` inutilizzabile
 * ("Expected 0 arguments"); qui la firma e' quella semplice che serve.
 */
export const tr = (key: string, options?: Record<string, unknown>): string =>
  (i18n as unknown as { t: (k: string, o?: Record<string, unknown>) => string }).t(key, options);

export default i18n;
